import React, { useState, useMemo, useEffect, memo } from "react";
import CaseStudyCard from "./CaseStudyCard";
import Button from "../elements/Button";
const CaseList = ({ caseStudies }) => {
  const [count, setCount] = useState(1);
  const casesLength = useMemo(() => caseStudies.length, [caseStudies]);
  const handleLoadMore = () => {
    setCount((count) => count + 2);
  };
  useEffect(() => {
    setCount(1);
  }, [caseStudies]);
  return (
    <>
      {" "}
      <div className="sources__container-list">
        {caseStudies.map((item, index) => {
          if (index > count) return null;
          return <CaseStudyCard data={item} key={index} />;
        })}
      </div>
      <div className="sources__container-cta">
        {casesLength - 1 > count && (
          <Button
            className={"connector__cta-btn connector__cta-btn1"}
            onClick={handleLoadMore}
          >
            Load More
          </Button>
        )}
      </div>
    </>
  );
};

export default memo(CaseList);
